import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { Dash, Plus } from 'react-bootstrap-icons'


const faqs = [{
  question: "Who are Ontik?",
  answer: "Ontik, registered as Ontik Technologies limited, is a UK based technology company building payment and credit risk software. Company number 14374185",
  isOpen: false
},
{
  question: "What is Pay by bank?",
  answer: <span>Pay by bank utilise open banking to transfer funds directly from your account to the receivers account. Transactions are immediate, safe and easy to complete.<br />
    Open banking enables third-party financial service providers to initiate bank transfers via APIs, facilitating secure payment processes.<br />
    In the UK, open banking is regulated by the Competition and Markets Authority (CMA) and overseen by the Open Banking Implementation Entity (OBIE). Banks provide APIs through a standardised framework, ensuring secure data sharing and compliance with strict regulatory standards.</span>,
  isOpen: false
},
{
  question: "Are these payments secure?",
  answer: "All payments are completed by services under the internationally agreed PISP licence. This means your payments are guaranteed to be secure and your payment data cannot be obtained by any third parties.",
  isOpen: false
},
{
  question: "How to make a payment?",
  answer: "Simply select your payment option and enter the information required. For pay by bank you will be redirected to your banking app to authorise the payment. For card payments your information is handled securely by Stripe who will process the payment.",
  isOpen: false
},
{
  question: "Why did my payment fail?",
  answer: "A failed payment means that either your bank or our payment providers have failed to process the transaction. This could be, for example, due to insufficient funds or fraud prevention. The funds will not have been taken from your account. You will be able to re-attempt payment. If the error continues you will need to contact your banking provider. ",
  isOpen: false
}]

export default function FAQs() {
  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
        <div className="mx-auto max-w-4xl">
          <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Frequently asked questions
          </h2>
          <dl className="mt-16 divide-y divide-gray-900/10">
            {faqs.map((faq) => (
              <Disclosure key={faq.question} as="div" className="py-6 first:pt-0 last:pb-0">
                <dt>
                  <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900">
                    <span className="text-base/7 font-semibold">{faq.question}</span>
                    <span className="ml-6 flex h-7 items-center">
                      <Plus aria-hidden="true" className="size-6 group-data-[open]:hidden" />
                      <Dash aria-hidden="true" className="size-6 group-[&:not([data-open])]:hidden" />
                    </span>
                  </DisclosureButton>
                </dt>
                <DisclosurePanel as="dd" className="mt-2 pr-12">
                  <p className="text-base/7 text-gray-600">{faq.answer}</p>
                </DisclosurePanel>
              </Disclosure>
            ))}
          </dl>
          <h1 className="mt-16 font-semibold mb-4">Contact us</h1>
          <p>If you have any issues or questions, please reach out to us at <a className="text-primary font-bold" href="mailto:support@ontik.io">support@ontik.io</a> and a member of our team will be in touch as soon as possible</p>
        </div>
      </div>
    </div>
  )
}
